import AppStoreBadge from "./AppStoreBadge";
import {
  TIKTOK_URL,
  INSTAGRAM_URL,
  CONTACT_EMAIL,
  PRIVACY_URL,
  TERMS_URL,
} from "../content";

export default function Footer() {
  return (
    <footer className="border-t-2 border-ink bg-ink text-bone">
      <div className="mx-auto max-w-7xl px-6 pb-12 pt-20 md:px-16 md:pt-28">
        <div className="flex flex-col justify-between gap-14 md:flex-row">
          <div>
            <div className="flex items-center gap-3">
              <span
                className="text-5xl tracking-tight text-bone md:text-6xl"
                style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
                data-testid="footer-logo"
              >
                nt.<span className="align-super text-[0.28em] tracking-normal">™</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-[15px] leading-relaxed text-bone/60">
              The standard for the modern press-on business.
            </p>
            <div className="mt-8">
              <AppStoreBadge testId="footer-appstore-btn" className="!border-bone !bg-bone !text-ink" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3 md:gap-20">
            <div>
              <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-bone/40">
                Follow
              </p>
              <ul className="mt-5 space-y-3 text-[15px]">
                <li>
                  <a
                    href={TIKTOK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-tiktok-link"
                    className="text-bone/80 transition-colors hover:text-pastel-pink"
                  >
                    TikTok — @nailtapeapp
                  </a>
                </li>
                <li>
                  <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="text-bone/80 transition-colors hover:text-pastel-pink"
                  >
                    Instagram — @nailtape_us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-bone/40">
                Contact
              </p>
              <ul className="mt-5 space-y-3 text-[15px]">
                <li>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    data-testid="footer-email-link"
                    className="text-bone/80 transition-colors hover:text-pastel-pink"
                  >
                    {CONTACT_EMAIL}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <p className="font-display text-xs font-bold uppercase tracking-[0.2em] text-bone/40">
                Legal
              </p>
              <ul className="mt-5 space-y-3 text-[15px]">
                <li>
                  <a
                    href={PRIVACY_URL}
                    data-testid="footer-privacy-link"
                    className="text-bone/80 transition-colors hover:text-pastel-pink"
                  >
                    Privacy policy
                  </a>
                </li>
                <li>
                  <a
                    href={TERMS_URL}
                    data-testid="footer-terms-link"
                    className="text-bone/80 transition-colors hover:text-pastel-pink"
                  >
                    Terms of use
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-bone/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-sans text-[10px] uppercase tracking-[0.24em] text-bone/40">
            © {new Date().getFullYear()} nailtape™
          </p>
          <div className="flex gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-pastel-pink/70" />
            <span className="h-1.5 w-1.5 rounded-full bg-pastel-blue/70" />
            <span className="h-1.5 w-1.5 rounded-full bg-pastel-mint/70" />
          </div>
        </div>
      </div>
    </footer>
  );
}
